module.exports = __webpack_public_path__ + "img/h5-openBrowser.ed7416e6.png";